import { LOGO_URL } from "../lib/brand";

export const FlowSphereLogo = ({ variant = "default", className = "" }) => (
  <span className={`flow-logo flow-logo--${variant} ${className}`.trim()} data-testid={`flowsphere-logo-${variant}`}>
    <img src={LOGO_URL} alt="FlowSphere System" loading={variant === "invoice" ? "eager" : "auto"} />
  </span>
);